export const externalCSSConfig = {
    markdown: {
      elegant: 'https://cdn.jsdelivr.net/gh/ryangrose/easy-pandoc-templates@948e28e5/css/elegant_bootstrap.css',
      github: 'https://cdnjs.cloudflare.com/ajax/libs/github-markdown-css/5.1.0/github-markdown.min.css',
      prism: 'https://cdnjs.cloudflare.com/ajax/libs/prism/1.27.0/themes/prism.min.css',
    },
    fonts: {
      roboto: 'https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500;700&display=swap',
      openSans: 'https://fonts.googleapis.com/css2?family=Open+Sans:wght@300;400;600;700&display=swap',
    },
    frameworks: {
      bootstrap: 'https://cdn.jsdelivr.net/npm/bootstrap@5.1.3/dist/css/bootstrap.min.css',
      bulma: 'https://cdn.jsdelivr.net/npm/bulma@0.9.4/css/bulma.min.css',
    },
  };